import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendBlockerContentStylesheet, extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { useBlocker, useBlockerStylesheet } from "../../..";
const BlockerHeader = (param)=>{
    let { closeIcon } = param;
    const { hasCloseIcon, HeaderTitle, HeaderContainer } = useBlockerStylesheet().extend(...extendCommonContentStylesheet).extend(...extendBlockerContentStylesheet);
    const blocker = useBlocker();
    const { blocker: { name }, texts: { blockerHeadline }, keepVariablesInTexts } = blocker;
    return /*#__PURE__*/ _jsx(HeaderContainer, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(HeaderTitle, {
                    className: closeIcon ? hasCloseIcon : undefined,
                    children: keepVariablesInTexts ? blockerHeadline : blockerHeadline.replace(/{{name}}/gi, name)
                }),
                closeIcon
            ]
        })
    });
};
export { BlockerHeader };
